/**
 * Block: new-triggermodal
 * Cloned from legacy inline script, then wired into the Vite bundle
 * (assets/js/blocks/index.js) — the block's pacificScripts flag pointed at a
 * legacy build that no longer exists, so the modals never opened on V2 pages.
 *
 * Opens/closes modals triggered by links with href="#triggermodal-{id}".
 * Markup: blocks-general/new-triggermodal/new-triggermodal.php
 * Styles: assets/css/blocks/new-triggermodal.css
 */

const ACTIVE_CLASS = 'active';
const BODY_CLASS = 'triggermodal-modal-active';

let lastTrigger = null;

function closeAll() {
  document.querySelectorAll('.triggermodal-modal.' + ACTIVE_CLASS).forEach((modal) => {
    modal.classList.remove(ACTIVE_CLASS);
  });
  document.body.classList.remove(BODY_CLASS);
  if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
  lastTrigger = null;
}

function openModal(modal, trigger) {
  closeAll();
  lastTrigger = trigger || null;
  document.body.classList.add(BODY_CLASS);
  modal.classList.add(ACTIVE_CLASS);
  const closeBtn = modal.querySelector('.triggermodal-modal-close');
  if (closeBtn) closeBtn.focus();
}

export function init() {
  if (!document.querySelector('.triggermodal-modal')) return;

  // Delegated: trigger links can live in any block on the page.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#triggermodal-"]');
    if (link) {
      const modal = document.getElementById(link.getAttribute('href').substring(1));
      if (!modal) return;
      event.preventDefault();
      openModal(modal, link);
      return;
    }

    const closeBtn = event.target.closest('.triggermodal-modal-close');
    if (closeBtn) {
      event.preventDefault();
      closeAll();
      return;
    }

    // Click on the dimmed backdrop (the modal element itself, outside its container).
    if (event.target.classList.contains('triggermodal-modal') && event.target.classList.contains(ACTIVE_CLASS)) {
      closeAll();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && document.body.classList.contains(BODY_CLASS)) closeAll();
  });
}
